export enum CopilotEvent {
  LoggedInAnalyticsEvent = 'LoggedInAnalyticsEvent',
  FirmwareUpgradeStartedAnalyticsEvent = 'FirmwareUpgradeStartedAnalyticsEvent',
  FirmwareUpgradeSucceededAnalyticsEvent = 'FirmwareUpgradeSucceededAnalyticsEvent',
  FirmwareUpgradeFailedAnalyticsEvent = 'FirmwareUpgradeFailedAnalyticsEvent'
};
